import type { SegmentMst } from '@libs/domain';
import { MstListSearch, MstListSearchRaw } from '@libs/templates/mst';

class SegmentMstListSearch
  extends MstListSearch
  implements Pick<SegmentMst['schema'], 'higherRankSegmentCode'>
{
  private constructor(
    mstListSearch: MstListSearch,
    readonly higherRankSegmentCode: string,
  ) {
    super(
      mstListSearch.codeRange,
      mstListSearch.name,
      mstListSearch.mstSpareName01Condition,
      mstListSearch.mstSpareName02Condition,
      mstListSearch.validityStartDateCondition,
      mstListSearch.validityEndDateCondition,
      mstListSearch.mstNoteCondition,
    );
  }

  static init() {
    return new SegmentMstListSearch(MstListSearch.baseInit(), '');
  }
}

class SegmentMstListSearchRaw
  extends MstListSearchRaw
  implements Pick<SegmentMst['record'], 'higherRankSegmentCode'>
{
  private constructor(
    mstListSearchRaw: MstListSearchRaw,
    readonly higherRankSegmentCode: string,
  ) {
    super(
      mstListSearchRaw.codeRange,
      mstListSearchRaw.isCodeRangeExcluded,
      mstListSearchRaw.name,
      mstListSearchRaw.mstSpareName01,
      mstListSearchRaw.isMstSpareName01BlankOnly,
      mstListSearchRaw.mstSpareName02,
      mstListSearchRaw.isMstSpareName02BlankOnly,
      mstListSearchRaw.validityStartDateFrom,
      mstListSearchRaw.validityStartDateTo,
      mstListSearchRaw.validityEndDateFrom,
      mstListSearchRaw.validityEndDateTo,
      mstListSearchRaw.mstNote,
      mstListSearchRaw.isMstNoteBlankOnly,
    );
  }

  static fromModel(model: SegmentMstListSearch) {
    return new SegmentMstListSearchRaw(MstListSearchRaw.baseFromModel(model), model.higherRankSegmentCode);
  }
}

export { SegmentMstListSearch, SegmentMstListSearchRaw };
